// import api from '@/helpers/api'

import LineChartWidget from "@/ui/widgets/charts/LineChartWidget";
import PieChartWidget from "@/ui/widgets/charts/PieChartWidget";
import CalendarChartWidget from "@/ui/widgets/charts/CalendarChartWidget";
import StatWidget from "@/ui/widgets/StatWidget";

const DateUTC = (date) => {
  return new Date(
    Date.UTC(
      date.substring(0, 4),
      parseInt(date.substring(5, 7)) - 1,
      date.substring(8, 10)
    )
  );
};

const datediff = (first, second) => {
  // Take the difference between the dates and divide by milliseconds per day.
  // Round to nearest whole number to deal with DST.
  return Math.floor((second - first) / (1000 * 60 * 60 * 24));
};

const resolveValue = (input, item) => {
  if (typeof input === "string" || input instanceof String) {
    return item[input];
  } else {
    return input(item);
  }
};

// const replace = (oldVal, newVal) => {
//   return newVal
// }

// const pivot = (arr, xField, seriesField, valueField, defaultValue = 0, combineFn = replace) => {
//   const series = [...new Set(arr.map(arrItem => resolveValue(seriesField, arrItem)))]

//   return arr.reduce((acc, item) => {
//     // find x item in result array
//     let arrItem = acc.find(accItem => accItem.date == resolveValue(xField, item))
//     const serie = resolveValue(seriesField, item)

//     // if x item doesn't exist => create it with default series values
//     if (!arrItem) {
//       arrItem = { date: resolveValue(xField, item) }
//       series.forEach(serie => arrItem[serie] = defaultValue)
//       acc.push(arrItem)
//     }

//     // assign current value
//     arrItem[serie] = combineFn(arrItem[serie], resolveValue(valueField, item))

//     return acc
//   }, [])
// }

// pivot(json, (item) => DateUTC(item.date), 'countPerWeek', 'typeId', 'typeAbbr')
const pivot = (arr, date, value, series, label) => {
  return arr.reduce((acc, item) => {
    const seriesValue = resolveValue(series, item);
    var arrItem = acc.find((accItem) => accItem.id === seriesValue);

    if (!arrItem) {
      arrItem = {
        id: seriesValue,
        name: resolveValue(label, item),
        data: [],
      };

      acc.push(arrItem);
    }

    arrItem.data.push({
      date: resolveValue(date, item), // DateUTC(item.date),
      value: resolveValue(value, item),
    });

    return acc;
  }, []);
};

export default function(context) {
  return {
    default: {
      name: 'Summary',
      items: [
        {
          component: StatWidget,
          requiresAuth: true,
          grid: {
            xs: { row: 1, col: 1, width: 4, height: 6 },
            sm: { row: 1, col: 1, width: 4, height: 4 },
            md: { row: 1, col: 1, width: 4, height: 2 },
            lg: { row: 1, col: 1, width: 4, height: 2 },
            xl: { row: 1, col: 1, width: 4, height: 2 },
          },
          fetch: () => {
            const url = context.$api.resolvePath(`metrics/last`);

            return new Promise((resolve, reject) => {
              // fetch(url)
              context.$api
                .get(url)
                .then((response) => response.json())
                .then((json) => json.find((item) => item.typeId === 1))
                .then((json) => {
                  const daysAgo = datediff(
                    DateUTC(json.lastDate),
                    new Date().setHours(0, 0, 0, 0)
                  );
                  return {
                    title: `Last: ${json.type.abbr}`,
                    value: daysAgo,
                    uom: daysAgo === 1 ? "day ago" : "days ago",
                  };
                })
                .then((json) => resolve(json))
                .catch((err) => reject(err));
            });
          },
        },
        {
          component: StatWidget,
          requiresAuth: true,
          grid: {
            xs: { row: 1, col: 5, width: 4, height: 6 },
            sm: { row: 1, col: 5, width: 4, height: 4 },
            md: { row: 1, col: 5, width: 4, height: 2 },
            lg: { row: 1, col: 5, width: 4, height: 2 },
            xl: { row: 1, col: 5, width: 4, height: 2 },
          },
          fetch: () => {
            const url = context.$api.resolvePath(`metrics/last`);

            return new Promise((resolve, reject) => {
              // fetch(url)
              context.$api
                .get(url)
                .then((response) => response.json())
                .then((json) => json.find((item) => item.typeId === 2))
                .then((json) => {
                  const daysAgo = datediff(
                    DateUTC(json.lastDate),
                    new Date().setHours(0, 0, 0, 0)
                  );
                  return {
                    title: `Last: ${json.type.abbr}`,
                    value: daysAgo,
                    uom: daysAgo === 1 ? "day ago" : "days ago",
                  };
                })
                .then((json) => resolve(json))
                .catch((err) => reject(err));
            });
          },
        },
        {
          component: StatWidget,
          requiresAuth: true,
          grid: {
            xs: { row: 1, col: 9, width: 4, height: 6 },
            sm: { row: 1, col: 9, width: 4, height: 4 },
            md: { row: 1, col: 9, width: 4, height: 2 },
            lg: { row: 1, col: 9, width: 4, height: 2 },
            xl: { row: 1, col: 9, width: 4, height: 2 },
          },
          fetch: () => {
            const url = context.$api.resolvePath(`metrics/last`);

            return new Promise((resolve, reject) => {
              // fetch(url)
              context.$api
                .get(url)
                .then((response) => response.json())
                .then((json) => json.find((item) => item.typeId === 4))
                .then((json) => {
                  const daysAgo = datediff(
                    DateUTC(json.lastDate),
                    new Date().setHours(0, 0, 0, 0)
                  );
                  return {
                    title: `Last: ${json.type.abbr}`,
                    value: daysAgo,
                    uom: daysAgo === 1 ? "day ago" : "days ago",
                  };
                })
                .then((json) => resolve(json))
                .catch((err) => reject(err));
            });
          },
        },

        {
          component: PieChartWidget,
          title: "Type",
          requiresAuth: true,
          contentClass: ["pa-4"],
          grid: {
            xs: { row: 7, col: 1, width: 12, height: 12 },
            sm: { row: 5, col: 1, width: 6, height: 6 },
            md: { row: 3, col: 1, width: 6, height: 3 },
            lg: { row: 3, col: 1, width: 6, height: 3 },
            xl: { row: 3, col: 1, width: 6, height: 3 },
          },
          fetch: () => {
            const url = context.$api.resolvePath(`metrics/by/type`);

            return new Promise((resolve, reject) => {
              // fetch(url)
              context.$api
                .get(url)
                .then((response) => response.json())
                .then((json) =>
                  json.map((item) => ({
                    name: item.type.abbr,
                    value: item.count,
                  }))
                )
                .then((json) => json.sort((a, b) => b.value - a.value))
                .then((json) => resolve(json))
                .catch((err) => reject(err));
            });
          },
        },
        {
          component: PieChartWidget,
          title: "Weekday",
          requiresAuth: true,
          contentClass: ["pa-4"],
          grid: {
            xs: { row: 19, col: 1, width: 12, height: 12 },
            sm: { row: 5, col: 7, width: 6, height: 6 },
            md: { row: 3, col: 7, width: 6, height: 3 },
            lg: { row: 3, col: 7, width: 6, height: 3 },
            xl: { row: 3, col: 7, width: 6, height: 3 },
          },
          fetch: () => {
            const url = context.$api.resolvePath(`metrics/by/weekday`);

            const weekdays = {
              0: "Monday",
              1: "Tuesday",
              2: "Wednesday",
              3: "Thursday",
              4: "Friday",
              5: "Saturday",
              6: "Sunday",
            };

            return new Promise((resolve, reject) => {
              // fetch(url)
              context.$api
                .get(url)
                .then((response) => response.json())
                .then((json) =>
                  json.map((item) => ({
                    name: weekdays[item.weekday],
                    value: item.count,
                  }))
                )
                .then((json) => json.sort((a, b) => b.value - a.value))
                .then((json) => resolve(json))
                .catch((err) => reject(err));
            });
          },
        },
      ],
    },
    trend: {
      name: 'Rolling Avg',
      items: [
        {
          component: LineChartWidget,
          // title: '90 Day Rolling Average',
          title: `${4 * 3} Week Rolling Average`,
          requiresAuth: true,
          grid: {
            xs: { row: 1, col: 1, width: 12, height: 24 },
            sm: { row: 1, col: 1, width: 12, height: 12 },
            md: { row: 1, col: 1, width: 12, height: 8 },
            lg: { row: 1, col: 1, width: 12, height: 5 },
            xl: { row: 1, col: 1, width: 12, height: 6 },
          },
          fetch: () => {
            const url = context.$api.resolvePath(`metrics/rollingavg`, {
              interval: 7 * 4,
              days: 7 * 4 * 3,
            });

            return new Promise((resolve, reject) => {
              // fetch(url)
              context.$api
                .get(url)
                .then((response) => response.json())
                .then((json) =>
                  pivot(
                    json,
                    (item) => DateUTC(item.date),
                    "countPerWeek",
                    "typeId",
                    "typeAbbr"
                  )
                )
                .then((json) => resolve(json))
                .catch((err) => reject(err));
            });
          },
        },
      ],
    },
    calendar: {
      name: "Calendar",
      items: [
        {
          component: CalendarChartWidget,
          title: "Calendar",
          requiresAuth: true,
          grid: {
            xs: { row: 1, col: 1, width: 12, height: 24 },
            sm: { row: 1, col: 1, width: 12, height: 12 },
            md: { row: 1, col: 1, width: 12, height: 8 },
            lg: { row: 1, col: 1, width: 12, height: 5 },
            xl: { row: 1, col: 1, width: 12, height: 6 },
          },
          fetch: () => {
            const url = context.$api.resolvePath(`items/all/1`, {
              itemsPerPage: 250,
            });
            console.log(url);
            return new Promise((resolve, reject) => {
              context.$api
                .get(url)
                .then((response) => response.json())
                .then((r) => {
                  console.log(r);
                  return r.rows.map((item) => ({
                    date: DateUTC(item.date),
                    value: item,
                  }));
                })
                // .then(json => pivot(json, (item) => DateUTC(item.date), 'countPerWeek', 'typeId', 'typeAbbr'))
                .then((json) => resolve(json))
                .catch((err) => reject(err));
            });
          },
        },
      ]
    },
  };
}
